// DO NOT MODIFY, this file is autogenerated by tools/build.ts
export * from 'firebase/app-check';
import { ɵzoneWrap } from '@angular/fire';
import {
  getToken as _getToken,
  initializeAppCheck as _initializeAppCheck,
  onTokenChanged as _onTokenChanged,
  setTokenAutoRefreshEnabled as _setTokenAutoRefreshEnabled
} from 'firebase/app-check';

export const getToken = ɵzoneWrap(_getToken, true);
export const initializeAppCheck = ɵzoneWrap(_initializeAppCheck, true);
export const onTokenChanged = ɵzoneWrap(_onTokenChanged, true);
export const setTokenAutoRefreshEnabled = ɵzoneWrap(_setTokenAutoRefreshEnabled, true);
